import { Box } from '@mantine/core';
import { useMove } from '@mantine/hooks';
import { useState } from 'react';
import classes from './table-slider.module.css';
import { TrackContainerContent } from './track-container-content';
export const TableSliderComponent = ({ value: valueProp, onChange: onChangeProp, visiblePercentage = 0.7, }) => {
    const [valueInternal, setValueInternal] = useState(valueProp ?? 0);
    const value = valueProp ?? valueInternal;
    const left = `calc(${value * 100}% - ${value} * var(--thumb-width))`;
    const thumbWidth = Math.max(82 * visiblePercentage, 20);
    const onChange = (newValue) => {
        setValueInternal(newValue);
        onChangeProp?.(newValue);
    };
    const { ref } = useMove(({ x }) => onChange(x));
    return (<Box className={classes.root} style={{
            width: 82,
            '--thumb-width': `${thumbWidth}px`,
        }}>
      <div className={classes.track} ref={ref}>
        <div className={classes.trackContainer}>
          <TrackContainerContent />
        </div>
        <div className={classes.thumb} style={{ left }}/>
      </div>
    </Box>);
};
